import dayjs from "dayjs";

const objectIDToTimestamp = (objectId: string | undefined) => objectId ? dayjs(parseInt(objectId.substring(0, 8), 16) * 1000) : dayjs("1970-01-01");

export default objectIDToTimestamp;
